import Stock from 'utils/stock'
import Option from 'utils/option'

function fetchStockData(params) {
  const { symbol, market, period, startTime, endTime, fq } = params

  const stockHelper = Stock.getStock(market, symbol)
  return stockHelper.getCandleData(period, startTime, endTime, fq)
}

function fetchOptionData(params) {
  const { symbol, expiry, strike, right, period, startTime, endTime } = params

  var option = new Option(symbol, expiry, strike, right)
  return option.klinePromise(period, startTime, endTime)
}

export function fetchCandleData(params) {
  if (params.secType === 'OPT') {
    return fetchOptionData(params)
  } else {
    return fetchStockData(params)
  }
}
